export const Experiments = {
  b2c_059_donate_to_yourself_v3: 'b2c_059_donate_to_yourself_v3',
  donate_now_track_click: 'donate_now_track_click',
};
